export default __webpack_public_path__ + "static/media/it_icon.e5ec72cb.svg";